// @ts-nocheck
import * as _ from 'lodash';
import format from 'date-fns/format';
import { saveData } from '../helpers';
import {
  SlickPlugin,
  SlickGridModel,
  SlickEventHandler,
  SlickEvent,
} from 'slickgrid';

interface DataExportOptions {
  filename: string;
  timestampFormat?: string;
  quoteChar?: string;
  delimiter?: string;
  localeCode?: string;
  getDataItems: <T>(visibleOnly: boolean) => T[];
}

export interface OnDataExportingEventArgs {
  status: boolean;
}

const DEFAULTS = {
  timestampFormat: 'yyyyMMdd-hhmm',
};

export class DataExport<T> implements SlickPlugin {
  pluginName = 'DataExport' as const;

  private readonly eventHandler: SlickEventHandler;
  private grid: SlickGridModel<T>;
  private readonly options: DataExportOptions;
  readonly onDataExporting: SlickEvent<OnDataExportingEventArgs>;

  constructor(options: DataExportOptions) {
    this.eventHandler = new SlickEventHandler();
    this.options = { ...DEFAULTS, ...options };
    this.onDataExporting = new SlickEvent();
  }

  public init(grid: SlickGridModel): void {
    this.grid = grid;
  }

  public destroy(): void {
    this.eventHandler.unsubscribeAll();
  }

  async exportData(format: string, locale: string = null) {
    try {
      this.onDataExporting.notify({ status: true });

      return await saveData(
        this.grid,
        this.options.getDataItems(true),
        this.getFilename(format),
        'csv',
        {
          delimiter: this.options.delimiter,
          quoteChar: this.options.quoteChar,
          localeCode: locale || this.options.localeCode,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.onDataExporting.notify({ status: false });
    }
  }

  getFilename(extension: string) {
    let ts = '';

    if (this.options.timestampFormat) {
      ts = '-' + format(new Date(), this.options.timestampFormat);
    }

    return `${this.options.filename}${ts}.${extension}`;
  }
}
